import type { FunctionComponent } from "react"

import { SocialNetworkItem } from "@/modules/companies/client/components/SocialNetworks/SocialNetworkItem"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

import styles from "./SocialNetworks.module.css"

export const SocialNetworks: FunctionComponent = () => {
  const { dataCompany, isSuccessCompany } = useCompanyFetch()

  if (!dataCompany || !isSuccessCompany) return null

  const { socialNetworks } = dataCompany.page
  const filteredSocialNetworks = socialNetworks.filter(socialNetwork => !!socialNetwork.url.trim())
  const showSocialNetworks = filteredSocialNetworks.length > 0

  if (!showSocialNetworks) return null

  return (
    <div className={styles.socialNetworks} data-testid="company_social_networks">
      {filteredSocialNetworks.map(socialNetwork => (
        <SocialNetworkItem key={socialNetwork.type} {...socialNetwork} />
      ))}
    </div>
  )
}
